/* eslint-disable */
export default {
  callerCall: 'Autor da chamada',
  transferCall: 'Transferir',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
